'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var safeString = function safeString(str) {
  return str.toLocaleLowerCase().replace(/[^A-Za-z0-9]/g, ' ').trim().split(/\s+/);
};

var id = exports.id = function id() {
  var _ref;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (_ref = []).concat.apply(_ref, _toConsumableArray(args.map(safeString))).join('-').toLowerCase();
};